import React from "react";

export default function VideoContainer({ title, embedUrl }) {
  return (
    <div className="w-full relative" style={{ paddingBottom: "56.25%" }}>
      <iframe
        width="100%"
        height="100%"
        top="0"
        left="0"
        style={{ position: "absolute" }}
        src={embedUrl}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={title}
      ></iframe>
    </div>
  );
}
